import { HTMLProps, ReactNode } from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import {
  space,
  color,
  layout,
  typography,
  background,
  flexbox,
  alignItems,
  justifyContent,
  justifyItems,
  flex,
  order,
  position,
  grid,
  gridArea,
  SpaceProps,
  ColorProps,
  LayoutProps,
  TypographyProps,
  BackgroundProps,
  FlexboxProps,
  AlignItemsProps,
  JustifyContentProps,
  JustifyItemsProps,
  FlexProps,
  OrderProps,
  PositionProps,
  GridProps,
  GridAreaProps,
} from 'styled-system'
import { theme } from 'utils'

interface IGutter {
  gutterX?: keyof typeof theme.space
  gutterY?: keyof typeof theme.space
}

const gutter = ({ gutterX, gutterY }: IGutter) =>
  css`
    ${gutterX && `> * + * { margin-left: ${theme.space[gutterX] || gutterX}};`}
    ${gutterY && `> * + * { margin-top: ${theme.space[gutterY] || gutterY}};`}
  `

const commonPropFunctions = [
  layout,
  space,
  position,
  typography,
  flex,
  order,
  gridArea,
  color,
  background,
  gutter,
]

interface IBoxProps
  extends SpaceProps,
    ColorProps,
    LayoutProps,
    TypographyProps,
    BackgroundProps,
    FlexProps,
    OrderProps,
    PositionProps,
    GridAreaProps,
    IGutter,
    Omit<
      HTMLProps<HTMLDivElement>,
      'color' | 'children' | 'width' | 'height' | 'size'
    > {
  gutter?: string
  children?: ReactNode
}

export interface IFlexProps extends IBoxProps, FlexboxProps {
  $gap?: string
}

export interface IGridProps
  extends IBoxProps,
    FlexboxProps,
    AlignItemsProps,
    GridProps,
    JustifyContentProps,
    JustifyItemsProps {}

export const Box = styled.div<IBoxProps>`
  ${commonPropFunctions}
`

export const Flex = styled.div<IFlexProps>`
  display: flex;
  ${({ $gap }) => $gap && `gap: ${$gap};`}
  ${commonPropFunctions}
  ${flexbox}
`

export const Grid = styled.div<IGridProps>`
  display: grid;
  ${commonPropFunctions}
  ${grid}
  ${alignItems}
  ${justifyContent}
  ${justifyItems}
`
